module.exports = __webpack_public_path__ + "static/media/ana-galhardo.ed59a41f.jpg";